import type { CopyType, CrawlCadence, PageType } from '@/types'

/**
 * Client accent palette — docs/01-design-system.md §2.4.
 * Deliberately excludes brand red and blue: a client chip that reads as a
 * primary button is a misread waiting to happen.
 */
export const ACCENT_COLORS = [
  '#7B4B94',
  '#0F766E',
  '#B45309',
  '#4338CA',
  '#9D174D',
  '#3F6212',
  '#0E7490',
  '#7C2D12',
] as const

export const COPY_TYPES: Array<{ value: CopyType; label: string }> = [
  { value: 'landing', label: 'Landing copy' },
  { value: 'email', label: 'Email' },
  { value: 'social', label: 'Social post' },
  { value: 'brochure', label: 'Brochure' },
  { value: 'other', label: 'Other' },
]

export const CADENCES: Array<{ value: CrawlCadence; label: string }> = [
  { value: 'manual', label: 'Manual only' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
]

export const PAGE_TYPES: PageType[] = [
  'program',
  'landing',
  'article',
  'testimonial',
  'media',
  'other',
]

/* ---------------------------------------------------------------- upload */

export const ACCEPTED_IMAGE = ['image/jpeg', 'image/png', 'image/webp', 'image/gif']
export const ACCEPTED_VIDEO = ['video/mp4', 'video/webm', 'video/quicktime']

/** 200 MB. Provisional — the real ceiling is a backend decision (docs/00-overview.md §5.2). */
export const MAX_UPLOAD_BYTES = 200 * 1024 * 1024

/* --------------------------------------------------------------- polling */

/** Crawl status poll interval while a run is live and the tab is focused. */
export const CRAWL_POLL_MS = 30_000

/** DataTable page size. No virtualisation in Phase 1 — see docs/05-implementation-plan.md §3. */
export const PAGE_SIZE = 50
